import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { clsx, colorSet } from '@components/Provider';
import { ActiveTabTypeEnum } from '../type';
import {
  Badge,
  BottomNavigation,
  BottomNavigationAction,
  makeStyles
} from '@material-ui/core';
import useUserActionLog, {
  Enum_Action_Button_Enum,
  CapaActivityType
} from '@hooks/useUserActionLog';
import {
  Report,
  Chat,
  OverflowMenuHorizontal,
  Notebook
} from '@carbon/icons-react';
import { useActiveTab } from '@hooks/useActiveTab';
import { GnbCount } from '@hooks/useGnbCount';
import { UpdateBadge } from '@components/UpdateBadge';
import { snackbarBottom } from '@vars';
interface BottomNavPresenterProps {
  gnbCount: GnbCount;
}

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    display: 'none',
    width: '100%',
    bottom: 0,
    height: 56,
    backgroundColor: colorSet.gray000,
    borderRadius: 0,
    zIndex: theme.zIndex.drawer + 9,
    '& .MuiBadge-dot': {
      marginTop: 5,
      marginRight: -6
    },
    [theme.breakpoints.down('md')]: {
      display: 'block',
      borderTop: `1px solid ${colorSet.gray400}`
    }
  },
  navBtn: {
    color: colorSet.gray600,
    '& .MuiSvgIcon-root': {
      color: colorSet.gray600
    },
    '&.Mui-selected': {
      color: colorSet.gray800,
      '& .MuiSvgIcon-root': {
        color: colorSet.gray800
      }
    },
    '& .MuiBottomNavigationAction-label': {
      fontSize: 12,
      marginTop: 2,
      whiteSpace: 'nowrap',
      '&.Mui-selected': {
        fontSize: 12,
        color: colorSet.gray800
      }
    }
  },
  countBadge: {
    '& .MuiBadge-badge': {
      whiteSpace: 'nowrap',
      width: 20,
      height: 20,
      fontSize: 12,
      marginTop: 5,
      minWidth: 13,
      border: `2px solid ${colorSet.gray000}`,
      backgroundColor: colorSet.errorBase
    }
  }
}));

const BottomNavPresenter: React.FC<BottomNavPresenterProps> = ({
  gnbCount
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { onInsertUserActionLogOne } = useUserActionLog();
  const activeTab = useActiveTab();
  const {
    newQuotationAndIntroductionCount,
    newChatCount,
    newPaymentManagementCount
  } = gnbCount;

  const hasNewPayment = !!newPaymentManagementCount;

  useEffect(() => {
    snackbarBottom(56);

    return () => {
      snackbarBottom(0);
    };
  }, []);

  return (
    <div className={classes.root}>
      <BottomNavigation
        value={activeTab}
        onChange={(event, newValue) => {
          if (newValue === ActiveTabTypeEnum.DASHBOARD) {
            onInsertUserActionLogOne(
              Enum_Action_Button_Enum.Button_Gnb_Tab_Dashboard,
              CapaActivityType.ButtonClick
            );
            history.push('/dashboard');
          } else if (newValue === ActiveTabTypeEnum.CHAT) {
            onInsertUserActionLogOne(
              Enum_Action_Button_Enum.Button_Gnb_Tab_Chat,
              CapaActivityType.ButtonClick
            );
            history.push('/chat');
          } else if (newValue === ActiveTabTypeEnum.PROFILE) {
            history.push('/mypage');
          } else if (newValue === ActiveTabTypeEnum.PAYMENT) {
            history.push('/payment');
          }
        }}
        showLabels
      >
        <BottomNavigationAction
          className={clsx(classes.navBtn, classes.countBadge)}
          value={ActiveTabTypeEnum.DASHBOARD}
          label="견적비교"
          icon={
            <Badge
              color="error"
              max={99}
              overlap="circular"
              invisible={newQuotationAndIntroductionCount < 1}
              badgeContent={newQuotationAndIntroductionCount}
            >
              <Report size={24} />
            </Badge>
          }
        />
        <BottomNavigationAction
          className={clsx(classes.navBtn, classes.countBadge)}
          value={ActiveTabTypeEnum.CHAT}
          label={'채팅'}
          icon={
            <Badge
              color="error"
              max={99}
              overlap="rectangular"
              invisible={newChatCount < 1}
              badgeContent={newChatCount}
            >
              <Chat size={24} />
            </Badge>
          }
        />

        <BottomNavigationAction
          classes={{
            root: classes.navBtn
          }}
          value={ActiveTabTypeEnum.PAYMENT}
          label="발주관리"
          icon={
            <UpdateBadge top={0} right={-2} invisible={!hasNewPayment}>
              <Notebook size={24} />
            </UpdateBadge>
          }
        />

        <BottomNavigationAction
          className={clsx(classes.navBtn)}
          value={ActiveTabTypeEnum.PROFILE}
          label="더보기"
          icon={<OverflowMenuHorizontal size={24} />}
        />
      </BottomNavigation>
    </div>
  );
};

export default BottomNavPresenter;
